Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
	get: function () {
		return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
	}
});

$('body').on('click touchstart', function () {
	const videoElement = document.getElementById('video-animation-background');
	const videoLoop = document.getElementById('video-animation-loop');

	if(videoElement && ! videoElement.playing) {
		videoElement.play();
	}

	if(videoLoop && ! videoLoop.playing) {
		videoLoop.play();
	}
});
